const { default: DataService } = require("./DataService");

class CreditCategoryDataService extends DataService {
    constructor() {
        super("kredit/category")
    }

    getList(keyword, currentPage, perPage) {
        return super.getList(keyword, currentPage, perPage)
            .then((data) => {
                return {
                    creditCategories: data.data !== null && data.data.errorMessage === undefined ? data.data : [],
                    errorMessage: data.data?.errorMessage,
                    needRelogin: data.data?.needRelogin,
                }
            })
    }
    
}

export default CreditCategoryDataService;